// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"RadioGroup_radioGroup__2uD6e","label":"RadioGroup_label__1PPJW"};